import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { cn } from "@/lib/utils";

interface QueryErrorCardProps {
  title?: string;
  description?: string;
  onRetry: () => void;
  isRetrying?: boolean;
  variant?: "default" | "pink";
  className?: string;
}

export function QueryErrorCard({
  title = "Unable to load data",
  description = "We had trouble fetching this content. Please try again.",
  onRetry,
  isRetrying = false,
  variant = "default",
  className,
}: QueryErrorCardProps) {
  const isPink = variant === "pink";

  return (
    <Card
      className={cn(
        "p-6 text-center",
        isPink && "border-pink-200 bg-pink-50/30",
        className
      )}
    >
      <RefreshCw
        className={cn(
          "w-10 h-10 mx-auto mb-3",
          isPink ? "text-pink-400" : "text-muted-foreground"
        )}
      />
      <h3 className="font-semibold text-foreground mb-2">{title}</h3>
      <p className="text-sm text-muted-foreground mb-4">{description}</p>
      <Button
        onClick={onRetry}
        disabled={isRetrying}
        size="sm"
        className={cn(
          "gap-2",
          isPink && "bg-pink-500 hover:bg-pink-600"
        )}
      >
        {isRetrying ? (
          <>
            <RefreshCw className="w-4 h-4 animate-spin" />
            Retrying...
          </>
        ) : (
          <>
            <RefreshCw className="w-4 h-4" />
            Try Again
          </>
        )}
      </Button>
    </Card>
  );
}
